import {Router} from 'vue-router'

export class IonicProxyService {
  router?: Router
}
